import type { FC } from "react";

import { Legend, Labels as LegendLabels } from "@similarweb/ui-components";

import { BacklinksChartColors } from "app/pages/digital-marketing/backlinks/shared/BacklinksConsts";
import { translate } from "app/filters/i18nFilter";
import { OvertimeChartSummaryRowContainer } from "app/pages/digital-marketing/backlinks/reports/overview/BacklinksOverviewStyledComponents";

export const BacklinksReferringOvertimeSummaryRow: FC = () => {
    return (
        <OvertimeChartSummaryRowContainer>
            <div data-automation="legend-referring-domains">
                <Legend
                    text={translate("digitalsuite.backlinks.overview.refdomains_count.title")}
                    dataLabel={LegendLabels.Bullet}
                    labelColor={BacklinksChartColors.REFDOMAINS}
                    gridRowGap="0px"
                />
            </div>
            <div data-automation="legend-backlinks">
                <Legend
                    text={translate("digitalsuite.backlinks.overview.backlinks_count.title")}
                    dataLabel={LegendLabels.Bullet}
                    labelColor={BacklinksChartColors.BACKLINKS}
                    gridRowGap="0px"
                />
            </div>
        </OvertimeChartSummaryRowContainer>
    );
};
